import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from "react-localize-redux";
import { isNullOrUndefined } from '../../store/storeFunctions';

class Money extends React.Component {
    static propTypes={
        value: PropTypes.number,
        fractionDigits: PropTypes.number,
        unit: PropTypes.number,
        currency: PropTypes.string
    };

    render() {
        if (isNullOrUndefined(this.props.value)) {
            if (!isNullOrUndefined(this.props.nullPlaceholder))
                return <span>{this.props.nullPlaceholder}</span>
            return null;
        }

        let forceFractionDigits = this.props.fractionDigits !== undefined && this.props.fractionDigits !== null && !isNaN(this.props.fractionDigits);
        let hasUnit = this.props.unit !== undefined && this.props.unit !== null && !isNaN(this.props.unit);
        let hasInf = this.props.infValue !== undefined && this.props.infValue !== null && !isNaN(this.props.infValue);
        let hasCurrency = this.props.currency !== undefined && this.props.currency !== null;
        let displayValue = hasUnit ? this.props.value / this.props.unit : this.props.value

        if (hasInf && Math.abs(displayValue) === Number(this.props.infValue))
            return displayValue >= 0 ? <span>inf</span> : <span>-inf</span>

        if (this.props.activeLanguage) {
            if (forceFractionDigits) {
                return (
                    <span>
                        {displayValue.toLocaleString(this.props.activeLanguage.code, {
                            minimumFractionDigits: this.props.fractionDigits, maximumFractionDigits: this.props.fractionDigits
                        })}
                        &nbsp;
                    {hasCurrency && this.props.currency}
                    </span>
                );
            } else
                return (
                    <span>{displayValue.toLocaleString(this.props.activeLanguage.code)}{hasCurrency && <>&nbsp;{this.props.currency}</>}</span>
                );
        } else
            return null;
    }
}

export default withLocalize(Money);
